// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionOperators_OperatorKvResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/production_operators/kv
 *
 * Returns the production operators projected into a flat id-keyed map of
 * `{ <production_operator_id>: <display_name> }`, built in the controller by
 * iterating So_production_operators_model::getByFranchise() over the user's
 * franchises. Used by dropdowns that expect a flat option map. Dynamic
 * numeric keys mean a Row class would mis-shape this into a list, so we keep
 * it as a typed map.
 *
 * @see So_production_operators_model::getByFranchise()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductionOperators_OperatorKvResponseDados = Record<number, string>;

export type ProductionOperators_OperatorKvResponse = ApiResponse<ProductionOperators_OperatorKvResponseDados>;

registerResponseContract('ProductionOperators_OperatorKvResponse', {})
